import DataService from './data-service';
import axios, { API_URL } from './http-service';

export default class CollectionService extends DataService {

  create = async (data: {}) => {
    const url = API_URL + '/collections';
    return this.handler(() => axios.post(url, data));
  }

  update = async (data: {}) => {
    const url = API_URL + '/collections';
    return this.handler(() => axios.put(url, data));
  }

  fetchFields = async () => {
    const url = API_URL + '/collections';
    return this.handler(() => axios.get(url));
  }

}
